import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class CellKey extends Cloneable {
    static NONE = new CellKey(0, "NONE");
    static HINT = new CellKey(1, "HINT");
    static TARGET = new CellKey(2, "TARGET");
    static CUSTOM = new CellKey(3, "CUSTOM");
    static EXCLUDE = new CellKey(4, "EXCLUDE");
    static BLOCK = new CellKey(5, "BLOCK");

    static _values = [
        CellKey.NONE,
        CellKey.HINT,
        CellKey.TARGET,
        CellKey.CUSTOM,
        CellKey.EXCLUDE,
        CellKey.BLOCK
    ];

    static getValues() {
        return CellKey._values;
    }

    static getValue(id) {
        let value = CellKey._values.find(v => v.id === id) || null;
        console.assert(value, "unknown value: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, CellKey.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof CellKey) {
            return CellKey._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "None") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof CellKey) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new CellKey());
        } else if (target instanceof CellKey) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(CellKey, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});